import { useEffect, useRef, useState } from "react";
import { Box, TableCell } from "@mui/material";

// "11:00:00" -> "11:00"
export const toTimeInputValue = (time: string | null | undefined): string => {
	if (!time) return "";
	return time.substring(0, 5);
};

// "11:00" -> "11:00:00"
export const toApiTimeValue = (time: string): string =>
	time.length === 5 ? `${time}:00` : time;

export const formatTime = (time: string | null | undefined): string => {
	if (!time) return "-";
	return time.substring(0, 5);
};

export interface EditableTimeCellProps {
	value: string | null | undefined;
	onChange: (value: string) => void;
	sx?: object;
	endAdornment?: React.ReactNode;
}

export const EditableTimeCell = ({
	value,
	onChange,
	sx,
	endAdornment
}: EditableTimeCellProps) => {
	const [editing, setEditing] = useState(false);
	const inputRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		if (editing) inputRef.current?.focus();
	}, [editing]);

	const commit = (inputValue: string) => {
		if (inputValue) onChange(toApiTimeValue(inputValue));
		setEditing(false);
	};

	return (
		<TableCell sx={sx}>
			{editing ? (
				<input
					ref={inputRef}
					type="time"
					defaultValue={toTimeInputValue(value)}
					onBlur={(e) => commit(e.target.value)}
					onKeyDown={(e) => {
						if (e.key === "Enter") commit((e.target as HTMLInputElement).value);
						if (e.key === "Escape") setEditing(false);
					}}
					style={{
						border: "1px solid #1976d2",
						borderRadius: 4,
						padding: "2px 4px",
						fontSize: "1rem",
						outline: "none",
						width: 100,
						background: "transparent",
						color: "inherit",
						colorScheme: "light"
					}}
				/>
			) : (
				<Box display="flex" alignItems="center" justifyContent="space-between">
					<span
						onClick={() => setEditing(true)}
						style={{ cursor: "pointer", display: "inline-block", width: 100 }}
					>
						{formatTime(value)}
					</span>
					{endAdornment}
				</Box>
			)}
		</TableCell>
	);
};
